import { TypeNavLinkPanelSkeleton } from "@customTypes/contentful";
import clsx from "clsx";
import styles from "./MegaNav.module.scss";
import NavLinkList from "./NavLinkList";

export const NavLinkPanel = ({
  linkList,
  menuActive,
}: {
  linkList: TypeNavLinkPanelSkeleton;
  menuActive: boolean;
}) => {
  const { fields } = linkList;

  return (
    <div className={clsx(styles.panels, "flex", "w-3/4")}>
      {fields.column1 && (
        <NavLinkList items={fields.column1} menuActive={menuActive} />
      )}
      {fields.column2 && (
        <NavLinkList items={fields.column2} menuActive={menuActive} />
      )}
      {fields.column3 && (
        <NavLinkList items={fields.column3} menuActive={menuActive} />
      )}
    </div>
  );
};
